export default __webpack_public_path__ + "static/media/correspondent2.284ee848.png";